module.exports = __webpack_public_path__ + "static/media/call_sharing_file.3866262c.svg";